import {GeneticData} from '../../types/dashboard-genetics-general.types';
import {GeneticFileProcessingStatus} from '../../types/dashboard-genetics-processing.types';
import {PROGRESS_STATUSES, UnknownError} from '../../../shared/symbols';
import {User} from '../../../auth/symbols';

/** Unique identifier for the dashboard genetics retrieve state. */
export const dashboardGeneticsRetrieveUniqueStateId = '__DashboardGeneticsRetrieve__';

/** State model for the dashboard genetics retrieve state. */
export interface DashboardGeneticsRetrieveStateModel {

  /** Contain `id` of user whose genetics is requested. */
  currentUserId: User['uid'];

  /** Describes if user requested public or private genetics data. */
  isPublicGenetics: boolean;

  /** Current status of loading actual genetics status. */
  getStatusProgress: PROGRESS_STATUSES;

  /** Last error that occurs during the loading actual genetics status. */
  lastGetStatusError: UnknownError;

  /** Contain most actual genetic file status (the highest process code with most actual date). */
  mostActualStatus: GeneticFileProcessingStatus;


  /** Current status of loading actual genetics status for the current user. */
  getOwnStatusProgress: PROGRESS_STATUSES;

  /** Last error that occurs during the loading actual genetics status for the current user. */
  lastGetOwnStatusError: UnknownError;

  /** Contain most actual genetic file status for the current user (the highest process code with most actual date). */
  mostActualOwnStatus: GeneticFileProcessingStatus;


  /** Current status of the processed genetics download. */
  loadGeneticsProgress: PROGRESS_STATUSES;

  /** Last error that occurs during the processed genetics download. */
  loadGeneticsError: UnknownError;

  /** Actual processed genetics data. */
  geneticData: GeneticData;
}

/** Default values for state initialization and reset. */
export const dashboardGeneticsRetrieveStateDefaults: DashboardGeneticsRetrieveStateModel = {
  currentUserId: null,
  isPublicGenetics: null,

  getStatusProgress: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastGetStatusError: null,
  mostActualStatus: null,

  getOwnStatusProgress: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastGetOwnStatusError: null,
  mostActualOwnStatus: null,

  loadGeneticsProgress: PROGRESS_STATUSES.NOT_INITIALIZED,
  loadGeneticsError: null,
  geneticData: null,
};
